var map = {
	"./Section 1/Contoh-soal-1.png": 59101,
	"./Section 1/Contoh-soal-2.png": 64159,
	"./Section 1/Contoh-soal-3.png": 82455,
	"./Section 3/Contoh-soal-1.png": 41243,
	"./Section 3/Contoh-soal-2.png": 12352,
	"./Section 3/Contoh-soal-3.png": 11699,
	"./Section 4/Contoh-soal-1.png": 32080,
	"./Section 4/Contoh-soal-2.png": 72467,
	"./Section 4/Contoh-soal-3.png": 47947
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39578;